// constants
import { ONBOARDING_FLOWS, ATLAS_ONBOARDING_STEPS } from "../client-config";

export const getCreateFlows = ({ biz = {}, access = {}, atlasOnboardingState = {} }) => {
	const { flowData, flowSteps } = atlasOnboardingState;
	const isOnboardingFlowEnabled = flowData?.name === ONBOARDING_FLOWS.ATLAS_ONBOARDING_FLOW;
	const showFullNav = flowSteps?.find((step) => step?.step?.name === "SHOW_FULL_NAV") ? true : false;

	const completedSteps = flowSteps?.filter((step) => step?.status === "complete")?.map((step) => step?.step?.name);
	const inprogressSteps = flowSteps?.filter((step) => step?.status === "inprogress")?.map((step) => step?.step?.name);

	const isCompanyDetailsStepComplete = completedSteps?.includes(ATLAS_ONBOARDING_STEPS.COMPLETE_COMPANY_DETAILS);
	const isBrandStepComplete = completedSteps?.includes(ATLAS_ONBOARDING_STEPS.CREATE_BRANDS);
	const isLocationStepComplete = completedSteps?.includes(ATLAS_ONBOARDING_STEPS.CONFIGURE_LOCATIONS);
	const isMenuStepInProgress = inprogressSteps?.includes(ATLAS_ONBOARDING_STEPS.CONFIGURE_MENUS);
	const isMenuStepComplete = completedSteps?.includes(ATLAS_ONBOARDING_STEPS.CONFIGURE_MENUS);
	const isInviteUsersStepComplete = completedSteps?.includes(ATLAS_ONBOARDING_STEPS.INVITE_USERS);

	const items =
		!access?.isNonHqReport && !access?.isNonHqAnalytics
			? [
					{
						label: biz?.isMenuOverCatalogueEnabled ? "Menu Management" : "Catalogue Management",
						key: "menu-management",
						render: true,
						childrenProps: [
							{
								label: "Menu",
								key: "menu",
								path: "/menus/new",
								render: biz?.isMenuOverCatalogueEnabled && access?.isCatalogueManagement
							},
							{
								label: "Category",
								key: "category",
								path: "/categories/new",
								render: access?.isCatalogueManagement
							},
							{
								label: "Item",
								key: "item",
								path: "/items/new",
								render: access?.isCatalogueManagement
							},
							{
								label: "Modifier Group",
								key: "modifier-group",
								path: "/modifier-groups/new",
								render: access?.isCatalogueManagement
							},
							{
								label: "Modifier",
								key: "modifier",
								path: "/modifiers/new",
								render: access?.isCatalogueManagement
							},
							{
								label: "Tax",
								key: "tax",
								path: "/taxes/new",
								render: access?.isCatalogueManagement
							},
							{
								label: "Charge",
								key: "charge",
								path: "/charges/new",
								render: access?.isCatalogueManagement
							},
							{
								label: "Tag Group",
								key: "tag-group",
								path: "/tags/group/new",
								render: access?.isCatalogueManagement
							},
							{
								label: "Tag",
								key: "tag",
								path: "/tags/tag/new",
								render: access?.isCatalogueManagement
							}
						]
					},
					{
						label: "Groups",
						key: "groups",
						render: true,
						childrenProps: [
							{
								label: "Item Group",
								key: "item-group",
								path: "/item-groups/new",
								render: access?.isCatalogueManagement && (!isOnboardingFlowEnabled || showFullNav)
							},
							{
								label: "Location Group",
								key: "location-group",
								path: "/location-groups/new",
								render: access?.isCatalogueManagement && (!isOnboardingFlowEnabled || showFullNav)
							}
						]
					},
					{
						label: "Schedules",
						key: "schedules",
						render: true,
						childrenProps: [
							{
								label: "Regular Schedule",
								key: "regular-schedule",
								path: "/timing-groups/new",
								render: access?.isCatalogueManagement && (!isOnboardingFlowEnabled || showFullNav)
							},
							{
								label: "Holiday Schedule",
								key: "holiday-schedule",
								path: "/timing-groups/holiday-new",
								render: access?.isCatalogueManagement && (!isOnboardingFlowEnabled || showFullNav)
							}
						]
					},
					{
						label: "Settings",
						key: "settings",
						render: true,
						childrenProps: [
							{
								label: "Brand",
								key: "brand",
								path: "/brands/new",
								render: access?.isAdmin && biz?.isMultibrandEnabled
							},
							{
								label: "Location",
								key: "location",
								path: "/locations/new",
								render: access?.isAdmin
							},
							{
								label: "User Invite",
								key: "user-invite",
								path: "/unified-access/invite",
								render: access?.isAdmin
							},
							{
								label: "API Account",
								key: "api-account",
								path: "/api-access/new",
								render: access?.isAdmin
							},
							{
								label: "Webhook",
								key: "webhook",
								path: "/webhooks/new",
								render: access?.isAdmin
							},
							{
								label: "Backup",
								key: "backup",
								path: "/backups/new",
								render: access?.isCatalogueManagement
							}
						]
					}
				]
			: [];
	return items;
};

export default getCreateFlows;
